export const WalletConnectIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_298_10795)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="url(#paint0_linear_298_10795)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.725 46.2281L89.5061 50.8505C90.1646 51.4785 90.1646 52.5087 89.5061 53.1367L67.969 74.0133C67.3105 74.6413 66.2476 74.6413 65.6141 74.0133L50.3292 59.1911C50.1753 59.0404 49.8998 59.0404 49.7458 59.1911L34.4609 74.0133C33.8024 74.6413 32.7395 74.6413 32.106 74.0133L10.4939 53.1367C9.83538 52.5087 9.83538 51.4785 10.4939 50.8505L15.2751 46.2281C15.9336 45.6001 16.9965 45.6001 17.6299 46.2281L32.9149 61.0504C33.0688 61.201 33.3479 61.201 33.4982 61.0504L48.7832 46.2281C49.4416 45.6001 50.5045 45.6001 51.138 46.2281L66.4265 61.0504C66.5768 61.201 66.8559 61.201 67.0062 61.0504L82.295 46.2281C83.0033 45.6001 84.0665 45.6001 84.725 46.2281ZM26.3856 35.4773C39.4195 22.8409 60.5772 22.8409 73.6111 35.4773L75.1821 37.0099C75.8371 37.638 75.8371 38.6681 75.1821 39.2962L69.8141 44.4962C69.4848 44.8228 68.9552 44.8228 68.6259 44.4962L66.475 42.4111C57.3635 33.5932 42.6333 33.5932 33.5217 42.4111L31.2206 44.6469C30.8913 44.9735 30.3581 44.9735 30.0288 44.6469L24.6642 39.4468C24.0058 38.8188 24.0058 37.7886 24.6642 37.1606L26.3856 35.4773Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_298_10795"
        x1="50"
        y1="0"
        x2="50"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#657DFF" />
        <stop
          offset="1"
          stopColor="#3050FB"
        />
      </linearGradient>
      <clipPath id="clip0_298_10795">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
